// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"5157":"547e2ec3","8704":"547e2ec3"}[chunkId] + ".chunk.css";
};